<template>
  <div>
    <b-modal ref="termsDisclosureModal" hide-footer body-class="p-0">
      <terms-disclosure
        @agreed="agreed"
        @dontAgree="dontAgree"
      ></terms-disclosure>
    </b-modal>
    <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
      <b-form role="form" @submit.prevent="handleSubmit(submitSettings)">
        <b-row>
          <b-col class="col-4">
            <b-card class="border shadow-sm d-flex h-100">
              <h3>Payment Reminders</h3>
              <p class="text-muted">
                Send upcoming membership renewal reminders to the patient.
              </p>
              <b-form-checkbox
                v-model="membershipSettings.membershipReminders"
                switch
                size="lg"
                class="pb-3"
              ></b-form-checkbox>
              <div v-if="membershipSettings.membershipReminders">
                <b-row style="max-width:300px" class="pt-3">
                  <b-col>
                    <label class="small">
                      How many days prior for monthly memberships?
                    </label>
                    <b-form-select
                      v-model="membershipSettings.membershipReminderDays"
                      :options="membershipPaymentPlanReminderDaysOptions"
                    ></b-form-select
                    ><br />
                  </b-col>
                </b-row>
                <b-row style="max-width:300px" class="pt-3">
                  <b-col>
                    <label class="small">
                      How many days prior for yearly memberships?
                    </label>
                    <b-form-select
                      v-model="
                        membershipSettings.membershipReminderDaysForYearlyMembership
                      "
                      :options="membershipPaymentPlanReminderDaysOptionsYearly"
                    ></b-form-select
                    ><br />
                  </b-col>
                </b-row>
              </div>

              <h3 class="pt-5">Past Due Balances</h3>
              <p class="text-muted">
                Include past-due amounts when processing upcoming renewals.
              </p>
              <b-form-checkbox
                v-model="membershipSettings.membershipDontProcessPastDue"
                switch
                size="lg"
                class="pb-3"
              ></b-form-checkbox>
            </b-card>
          </b-col>
          <b-col class="col-8">
            <b-card class="border shadow-sm p-0" style="margin-bottom: 0;">
              <h3>Membership Agreement</h3>
              <p class="text-muted">
                Set terms and conditions for membership authorizations and
                approvals.
              </p>
              <b-form-checkbox
                @change="setDefaultMembership"
                v-model="hasMembershipApproval"
                switch
                size="lg"
              ></b-form-checkbox>
              <div v-if="hasMembershipApproval">
                <user-template
                  :template="membershipSettings.membershipTemplateLegal"
                  :keyItems="membershipSettings.membershipKeyItems"
                  @templateUpdate="updateTemplate"
                ></user-template>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="pt-5">
          <b-col>
            <b-button type="submit" variant="primary"
              >Update Membership Settings</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import TermsDisclosure from "@/views/Components/Company/TermsDisclosure";
import UserTemplate from "@/views/Components/UserTemplate";

export default {
  components: {
    "user-template": UserTemplate,
    "terms-disclosure": TermsDisclosure,
  },
  props: { company: null, bindMembershipSettings: null },
  data() {
    return {
      hasMembershipApproval: null,
      membershipSettings: null,
      membershipPaymentPlanReminderDaysOptions: [],
      membershipPaymentPlanReminderDaysOptionsYearly: [],
    };
  },
  async mounted() {
    this.membershipSettings = await this.bindMembershipSettings();

    for (let i = 1; i <= 6; i++) {
      this.membershipPaymentPlanReminderDaysOptions.push({ value: i, text: i });
      this.membershipPaymentPlanReminderDaysOptionsYearly.push({
        value: i,
        text: i,
      });
    }

    this.membershipPaymentPlanReminderDaysOptionsYearly.push({
      value: 15,
      text: 15,
    });
    this.membershipPaymentPlanReminderDaysOptionsYearly.push({
      value: 30,
      text: 30,
    });
    this.membershipPaymentPlanReminderDaysOptionsYearly.push({
      value: 45,
      text: 45,
    });

    this.hasMembershipApproval =
      this.membershipSettings.membershipTemplateLegal != null;
  },
  methods: {
    setDefaultMembership() {
      if (this.hasMembershipApproval) {
        this.hasMembershipApproval = false;
        this.$refs.termsDisclosureModal.show();
      }
    },
    agreed() {
      this.$refs.termsDisclosureModal.hide();
      this.membershipSettings.membershipTemplateLegal = this.membershipSettings.defaultMembershipTemplateLegal;
      this.hasMembershipApproval = true;
    },
    dontAgree() {
      this.$refs.termsDisclosureModal.hide();
      this.membershipSettings.membershipTemplateLegal = "";
      this.hasMembershipApproval = true;
    },
    updateTemplate(m) {
      this.membershipSettings.membershipTemplateLegal = m;
    },
    async submitSettings() {
      if (
        !this.membershipSettings.membershipTemplateLegal &&
        this.hasMembershipApproval
      ) {
        this.$emitter.emit("error", "The membership template must be set.");

        return;
      }

      if (!this.hasMembershipApproval) {
        this.membershipSettings.membershipTemplateLegal = null;
      }

      this.$emit("updateMembershipSettings", this.membershipSettings);
    },
  },
};
</script>

<style></style>
